import { makeStyles } from '@material-ui/core';

export default makeStyles(() => ({
  container: {
    marginTop: '5.5rem',
  },
  items: {
    marginTop: '0.5rem',
  },
  spinner: {
    marginTop: '4rem',
    margin: 'auto',
  },
}));
